import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchEventos,
  fetchDestinatarios,
  createEvento,
  createDestinatario,
  vincularDestinatario,
  desvincularDestinatario,
  toggleDestinatarioActivo,
  setDestinatarioPrincipal
} from '../actions/adminActions';


const AdminView = () => {
  const dispatch = useDispatch();
  const [showNotifications, setShowNotifications] = useState(true);
  const [showModalNotif, setShowModalNotif] = useState(false);
  const [showModalDest, setShowModalDest] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState({ idEvento: null, idDestinatario: null });
  const [success, setSuccess] = useState(null);

  // Formularios
  const [eventoForm, setEventoForm] = useState({ codigoEvento: '', descripcion: '' });
  const [destinatarioForm, setDestinatarioForm] = useState({ email: '', nombre: '' });
  const [selectedDestinatarios, setSelectedDestinatarios] = useState({});

  const { eventos, destinatarios, loading, error } = useSelector(state => state.admin);

  // Refrescar ambos siempre juntos
  const refreshData = () => {
    dispatch(fetchEventos());
    dispatch(fetchDestinatarios());
  };

  useEffect(() => {
    refreshData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  // Handlers formularios
  const handleEventoChange = e => {
    setEventoForm({ ...eventoForm, [e.target.name]: e.target.value });
  };
  const handleEventoSubmit = async e => {
    e.preventDefault();
    setShowModalNotif(false);
    const formData = { ...eventoForm, activo: '1' };
    await dispatch(createEvento(formData));
    setEventoForm({ codigoEvento: '', descripcion: '' });
    setSuccess('Notificación creada exitosamente');
    refreshData();
  };
  const handleDestinatarioChange = e => {
    setDestinatarioForm({ ...destinatarioForm, [e.target.name]: e.target.value });
  };
  const handleDestinatarioSubmit = async e => {
    e.preventDefault();
    setShowModalDest(false);
    const formData = { ...destinatarioForm, activo: true };
    await dispatch(createDestinatario(formData));
    setDestinatarioForm({ email: '', nombre: '' });
    setSuccess('Destinatario creado exitosamente');
    refreshData();
  };

  // Vincular y desvincular
  const handleVincular = async (idEvento, idDestinatario) => {
    await dispatch(vincularDestinatario(idEvento, idDestinatario));
    refreshData();
  };
  const handleDesvincular = (idEvento, idDestinatario) => {
    setConfirmData({ idEvento, idDestinatario });
    setShowConfirmModal(true);
  };
  const confirmDesvincular = async () => {
    await dispatch(desvincularDestinatario(confirmData.idEvento, confirmData.idDestinatario));
    setShowConfirmModal(false);
    refreshData();
  };
  const handleToggleActivo = async (idDestinatario) => {
    await dispatch(toggleDestinatarioActivo(idDestinatario));
    refreshData();
  };
  const handleSetPrincipal = async (idEvento, idDestinatario) => {
    await dispatch(setDestinatarioPrincipal(idEvento, idDestinatario));
    refreshData();
  };

  return (
    <div className="container-fluid py-4 px-2 px-md-4 admin-bg">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-9">
          <h2 className="mb-4 text-center fw-bold" style={{color: 'rgb(242, 10, 97)'}}>Panel de Administrador</h2>
          <div className="accordion" id="adminAccordion">
            {/* Sección Notificaciones */}
            <div className="card mb-4 shadow-sm border-0">
              <div className="card-header bg-white" id="headingNotifications">
                <h5 className="mb-0 d-flex align-items-center justify-content-between">
                  <span><i className="bi bi-bell-fill me-2"></i>Notificaciones</span>
                  <button
                    className="btn p-0 border" // 'border' le da un borde sutil para que se note el límite del botón blanco
                    type="button"
                    onClick={() => setShowNotifications(!showNotifications)}
                    aria-expanded={showNotifications}
                    aria-controls="collapseNotifications"
                    style={{ 
                      backgroundColor: 'white', 
                      color: '#800000', // Color bordo
                      minWidth: '45px',  // <--- Esto lo hace más ancho
                      height: '30px',    // Altura controlada
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1rem' 
                    }}
                  >
                    {showNotifications ? (
                      <i className="bi bi-chevron-up"></i> 
                    ) : (
                      <i className="bi bi-chevron-down"></i>
                    )}
                  </button>
                </h5>
              </div>
              {showNotifications && (
                <div id="collapseNotifications" className="collapse show">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                     {/* <button
                        className="btn btn-primary shadow-sm"
                        onClick={() => setShowModalNotif(true)}
                        style={{ fontSize: '0.85rem', padding: '0.375rem 0.75rem' }}
                      >
                        <i className="bi bi-plus-circle me-2"></i>Agregar Notificación
                      </button>*/}
                    </div>
                    {success && <div className="alert alert-success mb-3">{success}</div>}
                    {loading && <div>Cargando...</div>}
                    {error && <div className="alert alert-danger">{error}</div>}
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover table-sm align-middle bg-white" style={{ borderSpacing: '0 5px' }}>
                        <thead className="table-light">
                          <tr>
                            <th>Código de notificación</th>
                            <th>Descripción</th>
                            <th>Destinatarios</th>
                            <th title="Solo puede haber un usuario principal por notificación. Será a quien se envíe el mail. El resto serán usuarios copiados." style={{ cursor: 'help' ,fontSize: '0.8rem' }} >
                              Usuario Principal
                              
                            </th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(eventos) && eventos.map(ev => (
                            <tr key={ev.IdEvento}>
                              <td style={{ padding: '12px' }}>{ev.CodigoEvento}</td>
                              <td style={{ padding: '12px' }}>{ev.Descripcion}</td>
                              
                              <td style={{ padding: '12px' }}>
                                {ev.Destinatarios && Array.isArray(ev.Destinatarios) && ev.Destinatarios.length > 0 ? (
                                  <div  >
                                    {ev.Destinatarios.map((dest, index) => (
                                      <div key={dest.idDestinatario}>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div>
                                            <div style={{ fontWeight: '500' }}>{dest.nombre}</div>
                                            <div className="text-muted" style={{ fontSize: '0.8rem' }}>{dest.email}</div>
                                          </div>
                                          <button 
                                            className="btn btn-danger btn-sm ms-2"
                                            onClick={() => handleDesvincular(ev.IdEvento, dest.idDestinatario)} 
                                            title="Quitar usuario"
                                            style={{ padding: '0.2rem 0.4rem', fontSize: '0.8rem' }}
                                          >
                                            <i className="bi bi-x-circle"></i>
                                          </button>
                                        </div>
                                        {index < ev.Destinatarios.length - 1 && <hr style={{ margin: '8px 0' }} />}
                                      </div>
                                    ))}
                                  </div>
                                ) : <span className="text-muted">Sin destinatarios</span>}
                              </td>
                              <td style={{ padding: '12px', textAlign: 'center' }}>
                                {ev.Destinatarios && Array.isArray(ev.Destinatarios) && ev.Destinatarios.length > 0 ? (
                                  <div className="d-flex flex-column gap-2 align-items-center">
                                    {ev.Destinatarios.map((dest, index) => (
                                      <div key={dest.idDestinatario} className="w-100">
                                        <div className="d-flex align-items-center justify-content-center">
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              id={`switch-${ev.IdEvento}-${dest.idDestinatario}`}
                                              checked={dest.esPrincipal === true}
                                              onChange={() => handleSetPrincipal(ev.IdEvento, dest.idDestinatario)}
                                              style={{ cursor: 'pointer', marginBottom: 0 }}
                                              title={dest.esPrincipal ? 'Usuario principal - Click para quitar principal' : 'Click para establecer como principal'}
                                            />
                                          </div>
                                          
                                        </div>
                                        {index < ev.Destinatarios.length - 1 && <hr style={{ margin: '8px 0' }} />}
                                      </div>
                                    ))}
                                  </div>
                                ) : <span className="text-muted">-</span>}
                              </td>
                              <td style={{ padding: '12px', minWidth: 180 }}>
                                <div className="d-flex flex-column flex-md-row gap-2">
                                  <select
                                    className="form-select form-select-sm mb-2 mb-md-0"
                                    value={selectedDestinatarios[ev.IdEvento] || ''}
                                    onChange={e => setSelectedDestinatarios({ ...selectedDestinatarios, [ev.IdEvento]: e.target.value })}
                                  >
                                    <option value="">Seleccionar usuario</option>
                                    {Array.isArray(destinatarios) && destinatarios
                                      .filter(dest => !ev.Destinatarios.some(d => d.idDestinatario === dest.idDestinatario))
                                      .map(dest => (
                                        <option key={dest.idDestinatario} value={dest.idDestinatario}>
                                          {dest.nombre} ({dest.email})
                                        </option>
                                      ))}
                                  </select>
                                  <button
                                    className="btn btn-sm btn-success"
                                    disabled={!selectedDestinatarios[ev.IdEvento]}
                                    onClick={() => {
                                      handleVincular(ev.IdEvento, selectedDestinatarios[ev.IdEvento]);
                                      setSelectedDestinatarios({ ...selectedDestinatarios, [ev.IdEvento]: '' });
                                    }}
                                    title="Agregar usuario"
                                  >
                                    <i className="bi bi-person-plus"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Sección de Usuarios dentro de Notificaciones */}
                    <div className="mt-4">
                      <h5 className="mb-3 text-secondary"><i className="bi bi-people-fill me-2"></i>Usuarios</h5>
                      <button
                        className="btn btn-primary shadow-sm mb-3"
                        onClick={() => setShowModalDest(true)}
                        style={{ fontSize: '0.85rem', padding: '0.375rem 0.75rem' }}
                      >
                        <i className="bi bi-person-plus me-2"></i>Agregar Usuario
                      </button>
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover table-sm align-middle bg-white" style={{ borderSpacing: '0 5px' }}>
                          <thead className="table-light">
                            <tr>
                              <th>Email</th>
                              <th>Nombre</th>
                              <th style={{ textAlign: 'center' }}>Activo</th>
                              <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(destinatarios) && destinatarios.map(dest => (
                              <tr key={dest.idDestinatario}>
                                <td style={{ padding: '12px' }}>{dest.email}</td>
                                <td style={{ padding: '12px' }}>{dest.nombre}</td>
                                <td style={{ padding: '12px', textAlign: 'center' }}><span className={`badge ${dest.activo ? 'bg-success' : 'bg-secondary'}`}>{dest.activo ? 'Sí' : 'No'}</span></td>
                                <td style={{ padding: '12px', textAlign: 'center' }}>
                                  {dest.activo ? (
                                    <button
                                      className="btn btn-warning btn-sm"
                                      onClick={() => handleToggleActivo(dest.idDestinatario)}
                                      title="Desactivar usuario"
                                      style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                                    >
                                      <i className="bi bi-person-dash me-1"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-success btn-sm"
                                      onClick={() => handleToggleActivo(dest.idDestinatario)}
                                      title="Activar usuario"
                                      style={{ fontSize: '0.8rem', padding: '0.25rem 0.5rem' }}
                                    >
                                      <i className="bi bi-person-check me-1"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Modal para crear notificación */}
            {showModalNotif && (
              <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Crear nueva notificación</h5>
                      <button type="button" className="btn-close" onClick={() => setShowModalNotif(false)}></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleEventoSubmit} autoComplete="off">
                        <div className="row g-3">
                          <div className="col-12">
                            <label className="form-label fw-bold">Código Evento</label>
                            <input
                              type="text"
                              className="form-control"
                              name="codigoEvento"
                              placeholder="Ej: NUEVA_SOLICITUD"
                              value={eventoForm.codigoEvento}
                              onChange={handleEventoChange}
                              required
                            />
                          </div>
                          <div className="col-12">
                            <label className="form-label fw-bold">Descripción</label>
                            <input
                              type="text"
                              className="form-control"
                              name="descripcion"
                              placeholder="Ej: Se genera una nueva solicitud"
                              value={eventoForm.descripcion}
                              onChange={handleEventoChange}
                              required
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotif(false)}>Cancelar</button>
                      <button type="submit" className="btn btn-primary" onClick={handleEventoSubmit}>Crear</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Modal para crear destinatario */}
            {showModalDest && (
              <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Crear nuevo usuario</h5>
                      <button type="button" className="btn-close" onClick={() => setShowModalDest(false)}></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleDestinatarioSubmit} autoComplete="off">
                        <div className="row g-3">
                          <div className="col-12">
                            <label className="form-label fw-bold">Email</label>
                            <input
                              type="email"
                              className="form-control"
                              name="email"
                              placeholder="Email"
                              value={destinatarioForm.email}
                              onChange={handleDestinatarioChange}
                              required
                            />
                          </div>
                          <div className="col-12">
                            <label className="form-label fw-bold">Nombre</label>
                            <input
                              type="text"
                              className="form-control"
                              name="nombre"
                              placeholder="Nombre"
                              value={destinatarioForm.nombre}
                              onChange={handleDestinatarioChange}
                              required
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowModalDest(false)}>Cancelar</button>
                      <button type="submit" className="btn btn-primary" onClick={handleDestinatarioSubmit}>Crear</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Modal de confirmación para desvincular */}
            {showConfirmModal && (
              <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Confirmar desvinculación</h5>
                      <button type="button" className="btn-close" onClick={() => setShowConfirmModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      <p>¿Estás seguro de quitar este destinatario de la notificación?</p>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</button>
                      <button type="button" className="btn btn-danger" onClick={confirmDesvincular}>Quitar</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminView;
